import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "The PM Test";
const DEFAULT_DESC = "Independent reviews and real-world comparisons of the software, technology, and tools property managers rely on every day.";

export function Seo({ title, description, image, noindex, type = "website", schema }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Does it pass The PM Test?`;
  const desc = description || DEFAULT_DESC;
  const url = typeof window !== "undefined" ? window.location.href : "";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
}
